const featuresData = [
  {
    icon: 'ri-file-list-3-line',
    title: '分类大全',
    desc: '韩漫、日漫、国漫三大类别精细整理，玄幻、恋爱、热血等十余种类型标签，快速定位你想看的内容。',
  },
  {
    icon: 'ri-search-line',
    title: '一搜即达',
    desc: '强大的漫画搜索功能，支持按作品名、作者名、类型标签多维度检索，找好看的漫画只需一键。',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '每日更新',
    desc: '追踪全网热门漫画更新动态，第一时间推送最新话，不错过任何一部追更作品的连载进度。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    desc: 'Web、iOS、Android 全平台覆盖，阅读进度云端同步，在家用电脑，出门用手机，无缝切换。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '完全免费',
    desc: '所有漫画内容免费在线阅读，无需注册即可浏览，无隐藏收费，纯粹为漫画爱好者打造。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-black text-foreground-950 mb-2">为什么选择酷看漫画</h2>
          <p className="text-sm text-foreground-500">五大优势，让你的漫画阅读体验更上一层楼</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {featuresData.map((feature, i) => (
            <div
              key={i}
              className="group p-5 rounded-xl bg-background-100 hover:bg-background-100/80 transition-colors duration-200 text-center"
            >
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-primary-100 flex items-center justify-center">
                <i className={`${feature.icon} text-xl text-primary-500`}></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}